// plugins/07.google-signin.client.ts
export default defineNuxtPlugin(() => {
	useHead({
		script: [
			{
				id: 'google-gsi-script',
				src: 'https://accounts.google.com/gsi/client',
				async: true,
				defer: true,
			},
		],
	})
})
